module.exports = {
    'banner': { home: 'ca-app-pub-1989821476531262/1130718185' },
    'interstitial': {
        classes: 'ca-app-pub-1989821476531262/5792303330',
        periods: 'ca-app-pub-1989821476531262/3205985679'
    },
};